module.exports = __webpack_public_path__ + "media/img/illustrations/clock-a44a63f8b1422283bc767f262db78db6.svg";